import { LoansSection } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/LoansCard/LoansSection.tsx';
import { useVehicleLoans } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestmentVehicleDetails/components/VehicleLoansCard/useVehicleLoans.ts';

interface Props {
	dealId: string;
	personId: string;
}

export const VehicleLoansCard = ({ dealId, personId }: Props) => {
	const { rows, isLoading, isError } = useVehicleLoans({ personId });

	return (
		<LoansSection
			dealId={dealId}
			rows={rows}
			isLoading={isLoading}
			isError={isError}
			showIssuer
		/>
	);
};
